import { DataList, Flex, Heading, Text } from "@radix-ui/themes";
import { format } from "date-fns";
import { startCase } from "lodash";

import { ContactRequest } from "../../../api/public";
import { Tag } from "../../../common/components";
import { ESTIMATED_ANNUAL_USAGE_LABEL_MAP } from "../../components/constants";
import { statusToTagColor } from "../hooks/utils";

type Props = {
  contactRequest: ContactRequest;
};

export const ContactRequestDetail = ({ contactRequest }: Props) => {
  return (
    <Flex direction="column" gap="2">
      <Heading size="3">Contact Request Information</Heading>
      <DataList.Root>
        <DataList.Item align="center">
          <DataList.Label>Product</DataList.Label>
          <DataList.Value>
            <Flex gap="1">
              <Text size="2">{contactRequest.raw_material.trade_name}</Text>
              <Text size="2" color="gray">
                {" "}
                by {contactRequest.raw_material.supplier_name}
              </Text>
            </Flex>
          </DataList.Value>
        </DataList.Item>
        <DataList.Item align="center">
          <DataList.Label>Status</DataList.Label>
          <DataList.Value>
            <Tag color={statusToTagColor(contactRequest.status)}>
              {startCase(contactRequest.status.toString())}
            </Tag>
          </DataList.Value>
        </DataList.Item>
        <DataList.Item align="center">
          <DataList.Label>Submitted At</DataList.Label>
          <DataList.Value>
            {format(contactRequest.submitted_at ?? "", "MM/dd/yyyy")}
          </DataList.Value>
        </DataList.Item>
        <DataList.Item align="center">
          <DataList.Label>Request Types</DataList.Label>
          <DataList.Value>
            <Flex gap="1">
              {contactRequest.request_types.map((requestType) => (
                <Tag key={requestType} size="2" color="blue">
                  {startCase(requestType)}
                </Tag>
              ))}
            </Flex>
          </DataList.Value>
        </DataList.Item>
        <DataList.Item align="center">
          <DataList.Label>Project Description</DataList.Label>
          <DataList.Value>{contactRequest.project_description}</DataList.Value>
        </DataList.Item>
        <DataList.Item align="center">
          <DataList.Label>Request</DataList.Label>
          <DataList.Value>{contactRequest.request}</DataList.Value>
        </DataList.Item>
        <DataList.Item align="center">
          <DataList.Label>Estimated Annual Usage</DataList.Label>
          <DataList.Value>
            <Tag color="blue" size="2">
              {
                ESTIMATED_ANNUAL_USAGE_LABEL_MAP[
                  contactRequest.estimated_annual_usage
                ]
              }
            </Tag>
          </DataList.Value>
        </DataList.Item>
      </DataList.Root>
    </Flex>
  );
};
